/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Externalid1Inputs */

const en__field_externalid1 = /** @type {(inputs: _Field_Externalid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External ID`)
};

/**
* | output |
* | --- |
* | "External ID" |
*
* @param {_Field_Externalid1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_externalid1 = /** @type {((inputs?: _Field_Externalid1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Externalid1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_externalid1(inputs)
});
export { _field_externalid1 as "_field_externalId" }